import { useDependencies } from "../useDependencies";
import { useAuth } from "src/apps/hooks/useAuth";
import { DocumentationArea } from "src/contexts/documentationArea/domain/DocumentationArea";
import { useDocumentationArea } from "../useDocumentationArea";
import { useDocumentationAreaMutation } from "../useDocumentationAreaMutation";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";
import { OrderFilesData } from "../uploadFiles/UploadFilesData";
import { updateOrderStatusToProcessing } from "../../utils/orderStatusUpdater";

export const useUploadActorOrderFiles = () => {
  const { token } = useAuth();
  const { documentationArea } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();

  const mutationFn = async (data: OrderFilesData) => {
    if (!documentationArea) throw new DocumentationAreaNotFoundError();

    return await documentationAreaController.patchActorOrder(
      token,
      documentationArea.getId(),
      documentationArea.getActor().getId(),
      data.orderId,
      data.files,
    );
  };

  const optimisticUpdate = (data: OrderFilesData, documentationArea: DocumentationArea) => {
    // Optimistically update the order status to "processing" when files are uploaded
    return updateOrderStatusToProcessing(
      documentationArea,
      documentationArea.getActor().getId(),
      data.orderId,
    );
  };

  const { mutate: uploadActorOrderFiles, isError: isUploadActorOrderFilesError } =
    useDocumentationAreaMutation<string, OrderFilesData>({
      mutationFn,
      optimisticUpdate,
    });

  return {
    uploadActorOrderFiles,
    isUploadActorOrderFilesError,
  };
};
